import Vue from 'vue';
import Vuex from 'vuex';
import invite from './invite.store';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    invite,
  },
});

export default store;
